<script lang="ts">
  import { _ } from 'svelte-i18n';
  export let isAppActive = true;
  export let isStartingInFuture = false;
</script>

<div class="bg-cubiq-dark-blue">
  <div
    class="mx-auto flex max-w-7xl items-center justify-center px-4 py-4 text-center sm:px-6 sm:py-6"
  >
    <h1
      class="font-cubiq-serif text-2xl font-bold leading-tight text-white sm:text-5xl"
    >
      {#if isStartingInFuture && !isAppActive}
        {$_('MBD Purchase Payback Registration Future')}
      {:else}
        {$_('MBD Purchase Payback Registration')}
      {/if}
    </h1>
  </div>
</div>
